<template>
  <a
    class="cf-link cf-link--black cf-link--heavy"
    href="https://cardfree.com/"
    target="_blank"
  >
    Powered by CardFree
  </a>
</template>


<script>
  export default {
    name: 'CardfreeBranding'
  };
</script>
